import { requestResetPasswordApi } from "@/features/auth/services/requestResetPassword";
import { Button } from "@/components/elements/Button";
import { Linkable } from "@/components/elements/Linkable";
import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { TResetPasswordQuery } from "@/features/auth/types/resetPasswordQuery";
import { AppRoutes } from "@/routes/config";
import { showError } from "@/utils/error";
import { toast } from "@/utils/toast";
import { getQueryFromURL } from "@/utils/url";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { text } from "@/theme/colors";
import { RESEND_EMAIL_RATE_LIMIT_MS, RESEND_EMAIL_BLOCKED_MESSAGE, RESEND_EMAIL_LOCALSTORAGE_KEY } from "@/constants/common";

type TRecoverCompletePageProps = {};

export const RecoverCompletePage: FC<TRecoverCompletePageProps> = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isResendBlocked = (): boolean => {
    const lastRequestTime = localStorage.getItem(RESEND_EMAIL_LOCALSTORAGE_KEY);
    if (!lastRequestTime) return false;
    const elapsed = Date.now() - parseInt(lastRequestTime, 10);
    return elapsed < RESEND_EMAIL_RATE_LIMIT_MS;
  };

  const handleResendEmail = async () => {
    if (isResendBlocked()) {
      toast.error(RESEND_EMAIL_BLOCKED_MESSAGE);
      return;
    }

    setIsSubmitting(true);
    try {
      const query = getQueryFromURL<TResetPasswordQuery>();
      const data = { email: query?.email ?? "" };
      await requestResetPasswordApi(data);
      localStorage.setItem(RESEND_EMAIL_LOCALSTORAGE_KEY, Date.now().toString());
      toast.success("メールが再度送信されました。メールボックスをご確認ください。");
    } catch (error) {
      showError(error);
    }
    setIsSubmitting(false);
  };

  return (
    <Stack gap={6} alignItems="center">
      <LoginLogo />
      <Typography variant="head20Bold">パスワード再発行メールの送信完了</Typography>
      <Typography variant="body14" width={400} color={text.secondary}>
        パスワードの再発行メールをご登録されているメールアドレス
        <br />
        宛に送信いたしました。
        <br />
        メールの内容に従ってパスワードを再発行してください。
      </Typography>
      <Button type="submit" variant="dark" fullWidth onClick={() => navigate(AppRoutes.login)}>
        ログイン画面へ
      </Button>
      <Linkable href={window.location.toString()} disabled={isSubmitting} onClick={handleResendEmail}>
        <Typography variant="body14" color={text.link}>
          {isSubmitting ? <CircularProgress size={20} /> : "メールの再送信（ご案内メールが届かない場合）"}
        </Typography>
      </Linkable>
    </Stack>
  );
};
